export const UPDATE_USER_NAME = '更新用户名'
export const SET_OPERATIONS_MAP = '存储操作列表'



// WEBPACK FOOTER //
// ./src/vuex/modules/base/mutation-types.js